import { NgClass } from '@angular/common';
import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule, MatMenuTrigger } from '@angular/material/menu';
import { ListOperation } from '../scrolling-list';

@Component({
  selector: 'operations-menu',
  templateUrl: './operations-menu.component.html',
  styleUrls: ['./operations-menu.component.scss'],
  imports: [
    MatIconModule,
    MatButtonModule,
    MatMenuModule,
    MatDividerModule,
    NgClass,
  ],
})
export class OperationsMenuComponent<T> {
  @Input() operations: ListOperation<T>[] = [];
  @Input() id: string;

  @Output() operationClick = new EventEmitter<string>();

  @ViewChild('matMenuTrigger') matMenuTrigger: MatMenuTrigger;

  protected handleClick(operationName: string) {
    this.operationClick.emit(operationName);
  }

  protected get singleActions() {
    return this.operations
      .filter((operation) => operation.showIn?.includes('single'))
      .filter((operation) => !(operation.hidden && operation.hidden()));
  }
}
